<template>
  <div class="footer">barakadev &copy; 2021</div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  min-height: 60px;
  background-color: #333;
  color: white;
  text-align: center;
  padding-top: 20px;
}
@media only screen and (max-width: 576px) {
  .footer {
    display: none;
  }
}
</style>
